"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageChart = void 0;
var react_1 = __importDefault(require("react"));
var utils_1 = require("../../utils");
var Chart_1 = require("./Chart");
var ChartLoading_1 = require("./ChartLoading/ChartLoading");
var utils_2 = require("./utils");
var UsageChart = function (_a) {
    var data = _a.data, date = _a.date, fuel = _a.fuel, unit = _a.unit, datePeriod = _a.datePeriod, comparisonType = _a.comparisonType, setDate = _a.setDate, disableLinks = _a.disableLinks, comparisonDate = _a.comparisonDate, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b;
    var legend = (0, utils_2.useChartLegend)(fuel, date, 
    // Don't add the comparison entries to the legend until loaded.
    isLoading ? 'noComparison' : comparisonType, comparisonDate);
    var formatter = unit === 'kwh' ? utils_1.formatKwh : utils_1.formatCost;
    return (react_1.default.createElement(ChartLoading_1.ChartLoading, { isLoading: isLoading },
        react_1.default.createElement(Chart_1.Chart, { formatter: formatter, legend: legend, barWidth: (0, utils_2.getBarWidth)(datePeriod), data: (0, utils_2.formatCombinedUsageForChart)(data, fuel, unit, datePeriod, formatter, disableLinks, setDate, comparisonType) })));
};
exports.UsageChart = UsageChart;
